<template>
    <v-row
      class="ma-0 pa-0"
      no-gutters
    >
      <v-dialog v-model="alerta" persistent max-width="500px">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text class="text-center">
            <v-icon size="200px" color="red">mdi-close-circle-outline </v-icon>
            <h1>El Nombre de Usuario o Contraseña es Incorrecto</h1>
            <br>
            <div class="v-btn v-btn--contained blue theme--dark display-2 ma-5 pa-5" @click="alerta = false">
              Aceptar
            </div>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-dialog>
      <v-col v-if="show" :lg="cols[0]" :md="6" :sm="cols[0]">
        <v-img src="/mantenimiento/img/login.jpg" class="img-responsive" :max-height="maxHeight"></v-img>
      </v-col>
      <v-col :lg="cols[1]" :md="6" :sm="cols[1]" class="align-self-center">
        <v-row class="justify-center">
          <v-col cols="12" md="12" sm="12" class="style-full ma-0 pa-0">
          </v-col>
          <v-col class="text-center" cols="12" md="12" sm="12">
            <img src="/mantenimiento/img/logotipo-300x115.png"/>
          </v-col>
          <v-col cols="8" md="8" sm="8">
            <v-text-field
              id="email"
              v-model="inputs['email']"
              :rules="[rules.required, rules.min6]"
              label="Nombre de Usuario"
              hint="Al menos 4 caracteres"
              counter
              @focus="onInputFocus"
              @input="onInputChange"
            ></v-text-field>
          </v-col>
          <v-col cols="8" md="8" sm="8">
            <v-text-field
              id="password"
              v-model="inputs['password']"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min8]"
              :type="show1 ? 'text' : 'password'"
              label="Contraseña"
              hint="Al menos 8 caracteres"
              counter
              @click:append="show1 = !show1"
              @keydown.enter="login"
              @focus="onInputFocus"
              @input="onInputChange"
            ></v-text-field>
          </v-col>
          <v-col cols="8" md="8" sm="8">
            <v-spacer></v-spacer>
            <v-btn
              block
              align-center
              justify-center
              color="success"
              :disabled="loading"
              :loading="loading"
              @click="login"
            >
              Iniciar Sesion
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>

export default {
  data() {
    return {
      show1: false,
      rules: {
        required: value => !!value || 'Requerido.',
        min6: v => v.length >= 4 || 'Minimo 4 caracteres',
        min8: v => v.length >= 8 || 'Minimo 8 caracteres',
      },
      inputs:{
        email: "",
        password: ""
      },
      inputName: "email",
      alerta: false,
      loading: false
    }
  },
  methods: {
    login () {
      let email = this.inputs.email
      let password = this.inputs.password
      this.loading = true;
      this.$store.dispatch('login', { email, password })
        .then(response => {
          if(response == 'auth_success'){
            this.$router.push('/home')
          }
          this.loading = false;
        })
        .catch(err => {
          console.log(err)
          this.loading = false;
          this.alerta = true
        })
    },
    onChange(input) {
      this.inputs[this.inputName] = input;
    },
    
    onInputChange(input) {
      this.inputs[this.inputName] = input;
    },
    onInputFocus(input) {
      this.inputName = input.target.id;
    }
  },
  computed: {
    show(){
      return (!this.$vuetify.breakpoint.xs);
    },
    maxHeight(){
      if(this.$vuetify.breakpoint.xs){
        return "0px";
      }
      else if(this.$vuetify.breakpoint.sm){
        return "250px";
      }
      else return "100vh";
    },
    cols () {
      if(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm){
       return [12,12]; 
      }
      else return [6,6]
    },
  },
}
</script>

<style scoped>
  .style-full{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .img-responsive{
    /*height:100vh !important;*/
    width: auto !important;
  }
</style>